// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3Ny1j","box":"WorkspacesBox_box__1Nhy4","node":"WorkspacesBox_node__R9v6g"};